import { render, staticRenderFns } from "./repeatmobile.vue?vue&type=template&id=2a863c68&scoped=true&"
import script from "./repeatmobile.vue?vue&type=script&lang=js&"
export * from "./repeatmobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a863c68",
  null
  
)

export default component.exports